<template>
    <div class="job-role">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5">
                <h6 class="mb-3 font-weight-bold text-left kova-text">Job Role</h6>
                    <a-select class="w-100 mb-4" size="large" placeholder="choose your area of speciality" style="width: 120px">
                        <a-select-option :key="category" v-for="category in categories">
                            {{category}}</a-select-option>
                    </a-select>  
                    <!-- <a-textarea size="large" placeholder="Project description" class="mx-auto mt-2" :autosize="{ minRows: 4, maxRows: 8 }"/> -->
                    <h6 class="mb-3 font-weight-bold kova-text text-left">Select Job Type</h6> 
                    <div class="text-left mb-4">
                        <label for="opt1" class="radio text-left">
                            <input type="radio" name="rdo" id="opt1" class="hidden"/>
                            <span class="label"></span>Remote Job
                        </label><br />

                        <label for="opt2" class="radio text-left">
                            <input type="radio" name="rdo" id="opt2" class="hidden"/>
                            <span class="label"></span>Office Job
                        </label><br />

                        <label for="opt3" class="radio text-left">
                            <input type="radio" name="rdo" id="opt3" class="hidden"/>
                            <span class="label"></span>Crowdsource Project
                        </label><br />
                    </div> 
                    <h6 class="mb-3 font-weight-bold text-left kova-text">Provide job description below</h6>
                    <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="htmlForEditor" placeholder="Write a project descriptions..."></vue-editor>

                <div class="container-fluid px-0 px-md-4 mb-5 mt-4">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="text-right kova-text pt-3 mr-4">
                <span @click="skip">Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div> -->
        </div>
        
 </div>
</template>
<script>

import { VueEditor } from "vue2-editor";

export default {
    name: 'job-role',
    components: {
        VueEditor
    },
    data(){
        return {
            htmlForEditor: "",
            categories: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'hire-talent/tech-stack'})
        },
        skip(){
            this.$router.push({path:'stack'})
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    }
}
</script>
<style scoped>

</style>